import api from '@/api'



const state = {
  demarcaciones: []
}

const getters = {
  demarcaciones: (state) => {
    return state.demarcaciones
  }
}

const mutations = {
  SET_DEMARCACIONES(state, demarcaciones) {
    state.demarcaciones = demarcaciones
  }
}

const actions = {
  async fetchDemarcaciones({ commit }) {

    try {
      const response = await api.demarcacion.getDemarcaciones()
      commit('SET_DEMARCACIONES', response.data)

    } catch (err) {
      console.error(err)
      throw err
    }

  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
